import React from 'react';

export default function ResultsBlock1_5Burden() {
  return (
    <section className="py-24 md:py-24 px-[3%] md:px-[3%] bg-surface border-b border-line">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-16 max-w-4xl mx-auto">
          <div className="text-[12px] font-semibold text-brand tracking-widest uppercase mb-6">
            CONTEXTO SANITARIO
          </div>
          <h2 className="text-[32px] md:text-[48px] font-bold text-ink mb-8 tracking-tight leading-[1.2]">
            Por qué importa actuar antes.
          </h2>
          <p className="text-[16px] md:text-[20px] text-slate leading-[1.6] max-w-3xl mx-auto mb-16">
            Las hospitalizaciones por Condiciones Sensibles al Cuidado Ambulatorio (ACSC) ilustran cómo las brechas de continuidad impactan en la atención de urgencia y la red hospitalaria.
          </p>
        </div>

        <div className="flex flex-col md:flex-row gap-6 lg:gap-8 mb-12">
          {/* Main Stats */}
          <div className="flex-1 bg-paper border border-line p-8 rounded-xl text-center flex flex-col justify-center">
            <h3 className="text-[14px] font-semibold text-ink tracking-widest uppercase mb-10 pb-4 border-b border-line">
              IMPACTO DEL NÚCLEO CARDIOMETABÓLICO ACSC (2019)
            </h3>
            
            <div className="flex flex-col gap-10">
              <div>
                <div className="text-[48px] font-bold text-ink leading-none mb-2">30,5%</div>
                <div className="text-[12px] font-semibold text-slate tracking-widest uppercase">
                  DE LOS EGRESOS ACSC PÚBLICOS
                </div>
              </div>
              
              <div>
                <div className="text-[48px] font-bold text-ink leading-none mb-2">42,1%</div>
                <div className="text-[12px] font-semibold text-slate tracking-widest uppercase">
                  DE LOS DÍAS CAMA ACSC
                </div>
              </div>
            </div>
          </div>

          {/* Context */}
          <div className="flex-1 flex flex-col gap-6">
            <div className="bg-surface border border-line p-8 rounded-xl">
              <h4 className="text-[12px] font-semibold text-brand tracking-widest uppercase mb-3">
                ¿Qué enfermedades incluye este núcleo?
              </h4>
              <p className="text-[16px] text-slate leading-[1.6]">
                Considera diabetes, insuficiencia cardíaca y enfermedad cerebrovascular (definición OPS). Representa una subsección de la carga cardiometabólica total (no incluye eventos como IAM o procedimientos como amputaciones, que suman carga adicional prevenible).
              </p>
            </div>
            
            <div className="bg-surface border border-line p-8 rounded-xl">
              <h4 className="text-[12px] font-semibold text-brand tracking-widest uppercase mb-3">
                ¿Qué significa ACSC?
              </h4>
              <p className="text-[16px] text-slate leading-[1.6]">
                Las Condiciones Sensibles al Cuidado Ambulatorio son un indicador poblacional de acceso, oportunidad, continuidad y capacidad resolutiva de la red.
              </p>
              <div className="mt-4 pt-4 border-t border-line">
                <p className="text-[14px] text-muted leading-[1.6]">
                  <strong>Limitación importante:</strong> No significa que cada evento individual fuera evitable o atribuible a una falla local. Es una métrica de presión sistémica aguas abajo.
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
